export const activate_ru = {
    load: 'Активация',
    positiveResponse: 'Активация прошла успешно',
    negativeResponse: 'Что-то пошло не так',
    repeatRequest: 'Вы уже зарегистрированы',
    linkMainPage: 'Главная страница',
    login: 'Вход',
}